import { render, staticRenderFns } from "./Okx.vue?vue&type=template&id=d6916af6&scoped=true&"
import script from "./Okx.vue?vue&type=script&lang=ts&"
export * from "./Okx.vue?vue&type=script&lang=ts&"
import style0 from "./Okx.vue?vue&type=style&index=0&id=d6916af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6916af6",
  null
  
)

export default component.exports